module.exports = function getResource(label, vars = []) {
    const resources = { back: 'Retour' };

    return resources[label];
};
